export const INVALID_ACCOUNT_MODALITY = 'INVALID_ACCOUNT_MODALITY'

const HTTP_UNPROCESSABLE_ENTITY = 422

interface CustomerDataErrorItem {
  code?: string
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

const readErrorItems = (data: unknown): CustomerDataErrorItem[] => {
  if (!isRecord(data) || !Array.isArray(data.errors)) {
    return []
  }

  return data.errors.filter(isRecord).map((item) => ({
    code: typeof item.code === 'string' ? item.code : undefined,
  }))
}

export const isInvalidModalityAccountError = (error: unknown) => {
  if (!isRecord(error) || error.status !== HTTP_UNPROCESSABLE_ENTITY) {
    return false
  }

  return readErrorItems(error.data).some((item) => item.code === INVALID_ACCOUNT_MODALITY)
}
